import apiClient from './client';

export const userService = {
  getMe: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
  updateUser: async (id: number, data: { [key: string]: any }) => {
    const response = await apiClient.put(`/users/${id}`, data);
    return response.data;
  },
  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await apiClient.post('/auth/change-password', { currentPassword, newPassword });
    return response.data;
  },
  resendVerificationEmail: async () => {
    const response = await apiClient.post('/auth/resend-verification');
    return response.data;
  },
  verifyEmail: async (token: string) => {
    const response = await apiClient.get(`/auth/verify-email/${token}`);
    return response.data;
  },
};
